import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { ThemeProvider } from './design-system/components/ThemeProvider';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Course from './pages/Course';
import FallPreventionCourse from './pages/FallPreventionCourse';
import ChokingManagementCourse from './pages/ChokingManagementCourse';
import BLSCPRCourse from './pages/BLSCPRCourse';
import BLSCPRModule from './pages/modules/BLSCPRModule';
import { ModuleProgressProvider } from './context/ModuleProgressContext';

import ModulePage from './pages/ModulePage';
import ModuleContentPage from './pages/ModuleContentPage';
import Community from './pages/Community';
import Dashboard from './pages/Dashboard';

// Import module pages
import UnderstandingFallRisks from './pages/modules/UnderstandingFallRisks';
import RiskAssessment from './pages/modules/RiskAssessment';
import CaregiverBestPractices from './pages/modules/CaregiverBestPractices';
import EmergencyResponse from './pages/modules/EmergencyResponse';
import TechnologyInnovations from './pages/modules/TechnologyInnovations';
import InitialAssessment from './pages/modules/cm/InitialAssessment';
import DocumentationAndAnalysis from './pages/modules/cm/DocumentationAndAnalysis';
import ImmediateResponse from './pages/modules/cm/ImmediateResponse';
import NotificationAndCommunication from './pages/modules/cm/NotificationAndCommunication';
import PostMonitoringAndAssessment from './pages/modules/cm/PostMonitoringAndAssessment';
import PreventMeasuresAndPatientEducation from './pages/modules/cm/PreventMeasuresAndPatientEducation';



function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <ModuleProgressProvider>
        <Router>
          <Box
            sx={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              bgcolor: "background.default",
            }}
          >
            <Navigation />
            <Box component="main" sx={{ flex: 1, pt: 0, pb: 3 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/courses" element={<Course />} />
                <Route path="/courses/bls-cpr" element={<BLSCPRCourse />} />
                <Route path="/bls-cpr" element={<BLSCPRCourse />} />
                <Route path="/bls-cpr/:moduleId" element={<BLSCPRModule />} />
                <Route path="/bls-cpr/:moduleId/:lessonId" element={<BLSCPRModule />} />
                <Route path="/bls-cpr/module/:moduleId/lesson/:lessonId" element={<BLSCPRModule />} />
                <Route
                  path="/courses/fall-prevention/*"
                  element={<FallPreventionCourse />}
                />
                <Route
                  path="/courses/choking-management/*"
                  element={<ChokingManagementCourse />}
                />
                <Route path="/community" element={<Community />} />
                <Route path="/moedule/:moduleId" element={<ModulePage />} />
                <Route
                  path="/module-content/:moduleId/:lessonId"
                  element={<ModuleContentPage />}
                />

                {/* Fall Prevention Course - Module Routes */}
                <Route
                  path="/modules/understanding-fall-risks"
                  element={<UnderstandingFallRisks />}
                />
                <Route
                  path="/modules/risk-assessment"
                  element={<RiskAssessment />}
                />
                <Route
                  path="/modules/caregiver-best-practices"
                  element={<CaregiverBestPractices />}
                />
                <Route
                  path="/modules/emergency-response"
                  element={<EmergencyResponse />}
                />
                <Route
                  path="/modules/technology-innovations"
                  element={<TechnologyInnovations />}
                />

                {/* CM Course - Module Routes */}
                <Route
                  path="/modules/cm/initial-assessment"
                  element={<InitialAssessment />}
                />
                <Route
                  path="/modules/cm/immediate-response"
                  element={<ImmediateResponse />}
                />
                <Route
                  path="/modules/cm/notification-and-communication"
                  element={<NotificationAndCommunication />}
                />
                <Route
                  path="/modules/cm/post-monitoring-and-assessment"
                  element={<PostMonitoringAndAssessment />}
                />
                <Route
                  path="/modules/cm/prevent-measures-and-patient-education"
                  element={<PreventMeasuresAndPatientEducation />}
                />
                <Route
                  path="/modules/cm/documentation-and-analysis"
                  element={<DocumentationAndAnalysis />}
                />
              </Routes>
            </Box>
          </Box>
        </Router>
      </ModuleProgressProvider>
    </ThemeProvider>
  );
}

export default App;
